<template>
  <div class="web-message-container">
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #popularize_app_id>
        <a-input
          v-decorator="['popularize_app_id',{rules: [
            { required: false, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入推广端appid"
        />
      </template>
      <template #popularize_app_secret>
        <a-input
          v-decorator="['popularize_app_secret',{rules: [
            { required: false, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入推广端appsecret"
        />
      </template>
      <template #doctor_app_id>
        <a-input
          v-decorator="['doctor_app_id',{rules: [
            { required: false, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入医生端appid"
        />
      </template>
      <template #doctor_app_secret>
        <a-input
          v-decorator="['doctor_app_secret',{rules: [
            { required: false, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入医生端appsecret"
        />
      </template>
    </basic-form>
    <div class="btn-container">
      <a-button
        :loading="btnIsLoading"
        type="primary"
        @click="$emit('handleSubmit')"
      >
        保存
      </a-button>
    </div>
  </div>
</template>
<script>
import { formDataMini } from '../data/index';
export default {
  props: ['btnIsLoading'],
  data() {
    return {
      formData: formDataMini,
    };
  },
  mounted() {},

};
</script>
<style lang="scss" scoped>
.web-message-container {
.btn-container{
  text-align: right;
  margin-top:20px;
}
}
</style>